import React from 'react';
import IconAlert from '../../assets/SidebarIcons/icon-alert-warning.svg';
import './style.scss';

const CustomAlert = ({ closeAlert, message, show, variant, isVerification = false, classes = "" }) => {
  const defaultClass = 'floating-alert alert alert-dismissible';
  let showClass = '';
  let variantClass = '';
  let iconClass = '';
  if (variant === 'danger') {
    variantClass = ' alert-danger';
    iconClass = 'fa fas fa-times';
  }
  if (variant === 'success') {
    variantClass = ' alert-success';
    iconClass = 'fa fas fa-check';
  }
  if (variant === 'warning') {
    variantClass = ' alert-warning';
    iconClass = 'fa fas fa-exclamation-triangle';
  }
  if (variant === 'information') {
    variantClass = ' alert-information';
    iconClass = '';
  }
  if (show) {
    showClass = ' show';
  }

  return (
    <div role="alert" className={defaultClass + variantClass + showClass + " " + classes}>
      <button type="button" className="close" onClick={closeAlert}>
        <span aria-hidden="true">×</span>
        <span className="sr-only">Close alert</span>
      </button>
      <span className="message">{message}</span>
      {iconClass && <i className={iconClass} />}
    </div>
  );
};

export default CustomAlert;
